import { Controller } from '@hotwired/stimulus';
import { eventListener } from '@inked/utilities';

export class FormController extends Controller {
  static targets = ['field'];
  static values = {
    dirty: {
      default: false,
      type: Boolean,
    },
    touched: {
      default: false,
      type: Boolean,
    },
  };

  connect() {
    this.stopFieldEvents = eventListener(
      this.fieldTargets,
      ['field:update'],
      event => {
        this.dirtyValue = event.detail.state.dirty
                          || this.fieldTargets.some(field => field.dataset.fieldDirtyValue === 'true');
        this.touchedValue = true;
      }
    );
  }

  dirtyValueChanged() {
    if (this.dirtyValue) return this.dispatch('dirty');

    this.dispatch('clean');
  }

  disconnect() {
    if (this.stopFieldEvents) this.stopFieldEvents();
  }

  preventSubmit(event) {
    if (event.key === 'Enter') event.preventDefault();
  }

  reset() {
    this.element.reset();
  }

  touchedValueChanged() {
    if (this.touchedValue) return this.dispatch('touched');
  }
}
